import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import $ from "jquery"

globalThis.backoffice = globalThis.backoffice || {};

export default class extends Controller {
  static targets = ["projectsSelect", "triggerObjectsSelect"]
  static values = {
    fetchProjectsAjaxUrl: String,
    fetchTriggerObjectsAjaxUrl: String
  }

  connect() {
    this.aceEditor = new backoffice.AceEditorModule();
    this.aceEditor.getAceEditor();
  }

  setAceEditorContent() {
    this.aceEditor.setAceEditorContentBeforeSubmit();
  }

  loadTriggerObjects() {
    const controller = this;

    get(`${this.fetchTriggerObjectsAjaxUrlValue}?project_id=${controller.projectsSelectTarget.value}`)
      .then(data => data.response.json())
      .then((data) => {
        const options = data.results.map(function(arr) {
          return {
            text: arr.html,
            id: arr.id
          }
        });

        $(controller.triggerObjectsSelectTarget).empty().select2({ data: options });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  sampleProjects(e) {
    e.preventDefault();

    const controller = this;

    get(`${this.fetchProjectsAjaxUrlValue}?sample=true`)
      .then(data => data.response.json())
      .then((data) => {
        const options = data.results.map(function(arr) {
          return {
            text: arr.html,
            id: arr.id
          }
        });

        $(controller.projectsSelectTarget).empty().select2({ data: options }).trigger("change");
      })
      .catch((error) => {
        console.error(error);
      });
  }

  sampleTriggerObjects(e) {
    e.preventDefault();

    const values = $(this.triggerObjectsSelectTarget).find("option:not([value=''])").map(function() {
      return $(this).val();
    });

    $(this.triggerObjectsSelectTarget).val(values[Math.floor(Math.random() * values.length)]).trigger("change");
  }
}
